<template>
  <div class="flex-page">
    <a-form
      class="form"
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="拍品名称">
        <a-input
          type="text"
          style="width: 600px"
          v-model="form.name"
        ></a-input>
      </a-form-item>

      <a-form-item label="拍品图片">
        <UploadFile @callback="uploaded" :mult="false" folder="auction" />
        <div><img style="max-height: 100px" :src="this.API + form.thumb" alt=""></div>
        <a-input style="width: 600px" placeholder="请输入图片地址" v-model="form.thumb" />
      </a-form-item>

      <a-form-item label="拍品编号">
        <a-input
          type="text"
          style="width: 600px"
          v-model="form.sn"
        ></a-input>
      </a-form-item>

      <a-form-item label="起拍价">
        <a-input-number :min="0" v-model="form.price" /> 元
      </a-form-item>

      <a-form-item label="说明信息">
        <a-textarea
          style="width: 600px"
          :auto-size="{ minRows: 3, maxRows: 6 }"
          v-model="form.desc"
        />
      </a-form-item>
    </a-form>
    <div class="buttons">
      <a-button type="primary" @click="sub">提交修改</a-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import UploadFile from '../../../components/uploadFile.vue'

export default {
  components: { UploadFile },
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 3,
        },
        wrapperCol: {
          span: 20,
        },
      },
      form: {}
    };
  },
  async created () {
    const id = this.$route.query.id;
    const r = await this.$axios.get('/auction/goods/getInfo?id=' + id);
    // console.log(r);
    if(r.status == 1){
      this.form = r.info
    }
  },
  methods: {
    moment,
    uploaded(file) {
      this.form.thumb = file.file_path;
    },
    async sub() {
      const that = this;
      const r = await that.$axios.post("/auction/goods/update", this.form);

      if (r.status == 1) {
        this.$router.back()
      }
    }
  },
};
</script>